import * as React from 'react';

import { IVariantsProps } from '../../../../model';
import { Container, VariantList } from '../../variantsStyled';
import { useVariantTransition } from '../useVariantTransition';

import { VariantTile } from './VariantTile';

export const VariantsTile: React.FC<IVariantsProps> = ({
  locale,
  selectedId: _selectedId,
  variants,
  currency,
}) => {
  const { handleClick, selectedId } = useVariantTransition(_selectedId);

  return (
    <Container data-testid="pd-variants-tile" id="pdVariantsTile">
      <VariantList itemsCount={variants.length}>
        {variants.map((item) => (
          <VariantTile
            item={item}
            locale={locale}
            unit={item.parameters?.unit ?? ''}
            isSelected={item.webId === selectedId}
            currency={currency}
            key={item.webId}
            onClick={handleClick}
          />
        ))}
      </VariantList>
    </Container>
  );
};
